export default __webpack_public_path__ + "static/media/Logout.cfd5af9f.svg";